import ReactSelect, { Props, GroupBase } from 'react-select';

const CustomSelect = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: Props<Option, IsMulti, Group>
) => (
  <ReactSelect
    {...props}
    styles={{
      ...{
        control: base => ({
          ...base,
          backgroundColor: 'none',
          width: '100%',
        }),
        singleValue: base => ({
          ...base,
          color: '#555',
          backgroundColor: 'none',
        }),
        input: base => ({
          ...base,
          color: '#555',
          backgroundColor: 'none',
        }),
      },
      ...props.styles,
    }}
    noOptionsMessage={props.noOptionsMessage || (() => 'Не найдено')}
  />
);

export default CustomSelect;
